export namespace SystemUsersConstants {
  export const CurrenciesLoading = 'CurrenciesLoading';
  export const SystemUserProfileView = 'SystemUserProfileView';
}
